/** Mirrors `DocumentIssuerMode` in agency-core. */
enum DocumentIssuerMode {
    /** The agency's own name, phone, address and email. */
    AGENCY = "AGENCY",
    /** Only the custom fields, used as typed: a blank field is not printed. */
    CUSTOM = "CUSTOM",
    /** No issuer data at all. */
    HIDDEN = "HIDDEN",
}

export default DocumentIssuerMode;
